import { useMutation, UseMutationOptions, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios';
import { invalidateOrganizationGroups } from './useGetOrganizationGroups';

type Params = { id: string };

export const useDeleteOrganizationGroup = (
  options?: UseMutationOptions<Params, AxiosError, Params>,
): UseMutationResult<Params, AxiosError, Params> => {
  const queryClient = useQueryClient();
  return useMutation<Params, AxiosError, Params>({
    mutationFn: async ({ id }) => {
      if (!id) throw new Error('Brak id grupy');
      await axiosInstance.delete('/v3-deleteOrganizationGroup', { data: { id } });
      return { id };
    },
    ...options,
    onSuccess: (...args) => {
      invalidateOrganizationGroups(queryClient);
      options?.onSuccess?.(...args);
    },
  });
};
